// extracted by mini-css-extract-plugin
export var underlinedLink = "_ot-0";